export enum OrderStatus {
  PENDING_PAYMENT = 'pending_payment',
  APPROVED = 'approved',
  CARGO_GIVEN = 'cargo_given',
  CANCELED = 'canceled',
  REFUNDED = 'refunded',
  PROCESSING = 'processing',
  READY_TO_SHIP = 'ready_to_ship',
}

export const orderStatusNameMap: Record<OrderStatus, string> = {
  [OrderStatus.PENDING_PAYMENT]: 'Ödeme Bekleniyor',
  [OrderStatus.APPROVED]: 'Onaylandı',
  [OrderStatus.CARGO_GIVEN]: 'Kargoya Verildi',
  [OrderStatus.CANCELED]: 'İptal Edildi',
  [OrderStatus.REFUNDED]: 'İade Yapıldı',
  [OrderStatus.PROCESSING]: 'Hazırlanıyor',
  [OrderStatus.READY_TO_SHIP]: 'Kargolanmaya Hazır',
};
